import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../main-content/sevices/product.service';
import { environment } from '../../../environments/environment';
import { SelectedProductService } from './../../main-content/sevices/selected-product.service';
import { NumericLiteral } from 'typescript';
import { NotificationService } from '../../../app/_services/notification.service';
import { StateService } from '../../main-content/sevices/state.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {

  public pageId: number = 0;
  public items: any = [];
  constructor(private route: Router, private stateService: StateService, private productService: ProductService, private notifyService: NotificationService, private selectedProductService: SelectedProductService) { }

  ngOnInit(): void {
    this.getProducts();
  }
  addToCart(currentItem) {
    debugger
    currentItem.isAddedToCart = true;
    this.selectedProductService.add(currentItem);
    this.notifyService.showSuccess("Add to Card Succcessfully", currentItem.ProductName)
  }
  onScroll() {

    this.pageId = this.pageId + 1;
    this.getProducts();
  }
  goToProductDetail(itemToSet) {
    this.stateService.setState(itemToSet);
    this.route.navigateByUrl("/productdetail");
  }
  updateCart(type, item) {
    if (type == "plus") {
      item.selectedQuantity = item.selectedQuantity + 1;
    } else {
      if (item.selectedQuantity >= 2)
        item.selectedQuantity = item.selectedQuantity - 1;
    }
    this.selectedProductService.items.forEach(element => {
      if (element.id == item.id) {
        element.selectedQuantity = item.selectedQuantity;
      }

    });
    this.selectedProductService.syncItems();
  }
  getProducts() {
    this.productService.getProducts(this.pageId, []).subscribe(resp => {

      if (resp.aaData != undefined || resp.aaData.length > 0) {
        resp?.aaData?.forEach(element => {
          let itemToPush = {};
          resp.aoColumns.forEach((col, i) => {
            if (i == 13) {
              var array = element[13].split(',');
              element[i] = environment.globalImagePath + 'ProductImages/' + array[0];
            }
            itemToPush[col] = element[i];
            itemToPush["isAddedToCart"] = false;
          });

          itemToPush["selectedQuantity"] = 1;
          console.log(itemToPush);
          this.items.push(itemToPush);
        });

      }

      console.log("this.items");
        console.log(this.items);
    });
  }



}
